import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxEchartsModule } from 'ngx-echarts';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChartViewerComponent } from './chart-viewer/chart-viewer.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ContentLoaderComponent } from './content-loader/content-loader.component';
import { CropImageComponent } from './crop-image/crop-image.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { PaymentProcessingOverlayComponent } from './payment-processing-overlay/payment-processing-overlay.component';
import { PwaInstallBannerComponent } from './pwa-install-banner/pwa-install-banner.component';
import { SavingOverlayComponent } from './saving-overlay/saving-overlay.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';

const COMPONENTS = [
  ErrorHandlerComponent,
  SplashScreenComponent,
  CropImageComponent,
  UploadProgressComponent,
  ChartViewerComponent,
  ContentLoaderComponent,
  ConfirmationDialogComponent,
  EmptyStateComponent,
  PwaInstallBannerComponent,
  PaymentProcessingOverlayComponent,
  SavingOverlayComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    ImageCropperModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    FormsModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FontAwesomeModule
  ],
  exports: [...COMPONENTS, NgxEchartsModule]
})
export class SharedComponentsModule {}
